import { Injectable } from "@angular/core";
import { Action, NgxsOnInit, Select, Selector, State, StateContext } from "@ngxs/store";
import { JwtAuthService } from "app/auth/services/jwt-auth.service";
import { Observable } from "rxjs";
import { AuthState } from "../auth/auth.state";
import { SifarniciStateModel } from "./codebooks.model";
import { SifarniciStateService } from "./codebooks.service";
import { first, tap } from "rxjs/operators";
import { DajSveInterneSifarnike } from "./codebooks.action";
import { DajSveSifarnikeZaRecnikPojmovaResponse } from "app/api/iop-metaregistar-api-reference";


@State<SifarniciStateModel>({
  name: "sifarnici",
  defaults: {
    sifarnici: null,
  },
})
@Injectable()
export class SifarniciState implements NgxsOnInit {

  @Select(AuthState.loggedInUser) loggedInUser$: Observable<any>;

  @Selector()
  static sifarnici(state: SifarniciStateModel): any | null {
    return state.sifarnici;
  }

  constructor(
    private sifarniciService: SifarniciStateService,
    private jwtService: JwtAuthService
  ) { }

  ngxsOnInit(ctx: StateContext<SifarniciStateModel>) {
    this.loggedInUser$.pipe(first(user => this.isUserValid(user))).subscribe(user => {
      let sifarnici = ctx.getState().sifarnici;
      if (!sifarnici) {
        console.log("Loading codebooks...")
        ctx.dispatch(new DajSveInterneSifarnike());
      }
    });
  }

  isUserValid(user: any) {
    return user && this.jwtService.isLoggedIn() ? true : false;
  }

  @Action(DajSveInterneSifarnike)
  DajSveInterneSifarnike(
    ctx: StateContext<SifarniciStateModel>,
    action: DajSveInterneSifarnike
  ) {
    return this.sifarniciService.dajSveInterneSifarnike().pipe(
      tap((response: DajSveSifarnikeZaRecnikPojmovaResponse) => {
        ctx.setState(this.setSifarnike(response));
      }),
    );
  }

  setSifarnike(sifarnici: any) {
    // console.log(sifarnici)
    return (state: SifarniciStateModel) => ({ ...state, sifarnici: sifarnici });
  }
}
